module.exports = __webpack_public_path__ + "img/fr_ambassador.583a038e.gif";